"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PORTFOLIO_HOME_SECURITY_OPTIONS = void 0;
exports.PORTFOLIO_HOME_SECURITY_OPTIONS = {
    POINT_CENTRAL_ID_VERIFICATION: 'point_central_id_verification',
    RENTLY_BLUE: 'rently_blue',
    RENTLY_LOCKBOX: 'rently_lockbox',
    RENTLY_SMART_LOCK: 'rently_smart_lock',
    RING: 'ring',
    SIMPLI_SAFE: 'simpli_safe'
};
